import { useCallback, useEffect } from 'react';
import pubsub, { PUBSUB } from 'src/lib/pubsub';
import { collectDDVariationFromEditor } from 'src/services/document';

export const useSubscribeForDocumentExports = (editor) => {
  const collectVariationsForExport = useCallback(() => {
    const variations = collectDDVariationFromEditor(editor);
    pubsub.publish(PUBSUB.COLLECTED_DOCUMENT_VARIATIONS_FOR_EXPORT, { variations });
  }, [editor]);

  useEffect(() => {
    const token = pubsub.subscribe(
      PUBSUB.COLLECT_DOCUMENT_VARIATIONS_FOR_EXPORT,
      collectVariationsForExport
    );

    return () => pubsub.unsubscribe(token);
  }, [collectVariationsForExport]);
};
